import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import ProductCardV2 from '../../../molecules/ProductCardV2'
// eslint-disable-next-line css-modules/no-unused-class
import s from './ProductCardListV2.scss'
// import useSlider from '../../../helpers/NukaSliderWrapper/useSlider'
import useMasonry from '../../../helpers/Masonry/useMasonry'
import { getSliderSettings, handleProductCarouselHighlighting } from './utils'

const ProductCardListV2 = ({
  data,
  carouselIsStickyNow,
  config,
  isMobile,
  SliderComponent,
}) => {
  const { products, productLinkTarget, dataGA } = data
  const {
    cardLayout,
    currency,
    ga,
    layout = 'vertical_1',
    cardHeight,
    logoCtaLessSpace,
    masonry = {},
    hideCardDiscountPrefix,
    cardCTAText,
    darkThemeLogoMsid,
    cardSubLayout,
    cardNoPrice,
    onCardClickAction,
    withoutCTA,
    showCardIndex,
    nudgeOnUserView,
    intersectionObserverRootMargin,
    stickyConfig,
    country,
    showOnlyLeadImage,
    offerText,
    intermediateURLConfig,
    cardWidth,
    logoinCTAContainer = false,
    showOfferText,
    imageId,
    logoConfig = {},
    flashDealMinDiscount,
    validAffiliateList,
    validCurrencyMap,
    priceSize,
    ga4,
    useGA4,
    affiliateName,
    windowFunctions = [],
    mobileView,
  } = config
  const isSlider = layout === 'slider'
  const [activeProductID, setActiveProductID] = useState('')
  const [activeCardIndex, setActiveCardIndex] = useState(0)
  const [isStickyCardClicked, setIsStickyCardClicked] = useState(false)

  // const SliderModule = useSlider(isSlider)
  const itemsPerRow =
    layout.indexOf('vertical_') !== -1 ? layout.split('vertical_')[1] : 1
  const containerClass = classNames({
    [s.container]: true,
    [s.horizontal_list]: layout === 'horizontal',
    [s.col_2_list]: layout === 'vertical_2',
    [s.col_5_list]: layout === 'vertical_5',
    [s.col_6_list]: layout === 'vertical_6',
    [s.fullwidth]: layout === 'vertical_1',
    // [s.slider_list]: isSlider,
  })
  const isCarousel = onCardClickAction === 'goToSection'

  const sliderSettings = getSliderSettings(cardLayout)

  useEffect(() => {
    if (isCarousel) {
      const observer = new IntersectionObserver(
        (entries) => {
          handleProductCarouselHighlighting(
            entries[0].rootBounds,
            products,
            setActiveProductID,
            stickyConfig
          )
        },
        {
          rootMargin: intersectionObserverRootMargin,
          threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
        }
      )
      products.forEach((product) => {
        const productCard = document.querySelector(
          `[data-msp_product_id*="${product.productID}"]`
        )
        if (productCard) {
          observer.observe(productCard)
        }
      })
    }
  }, [])
  const cardClass = s.card
  const masonryModule = useMasonry(layout === 'masonry')
  const { default: Masonry } = masonryModule || {}

  const productList = [...products]
  if (productList && productList.length > 0 && itemsPerRow) {
    const extraItems = productList.length % itemsPerRow

    if (productList.length > itemsPerRow && extraItems > 0 && itemsPerRow > 1) {
      productList.splice(-extraItems)
    }
  }
  let ProductCardList = []

  const getProductCardData = (product, GA) => {
    if (productLinkTarget) {
      return {
        ...product,
        productLinkTarget,
        ga: GA,
      }
    }
    return { ...product, ga: GA }
  }
  if (productList && productList.length > 0) {
    ProductCardList = productList.map((product, index) => (
      <ProductCardV2
        // eslint-disable-next-line react/no-array-index-key
        key={`${product.title}_${index}`}
        carouselIsStickyNow={carouselIsStickyNow} // #todo rename this prop for product card
        index={index}
        activeProductID={activeProductID}
        setIsStickyCardClicked={setIsStickyCardClicked}
        isStickyCardClicked={isStickyCardClicked}
        data={getProductCardData(product, dataGA)}
        config={{
          affiliateName,
          ga4,
          useGA4,
          layout: cardLayout,
          subLayout: cardSubLayout,
          height: cardHeight,
          currency,
          position: index + 1,
          ga,
          className: cardClass,
          logoCtaLessSpace,
          hideDiscountPrefix: hideCardDiscountPrefix,
          ctaText: cardCTAText,
          darkThemeLogoMsid,
          cardNoPrice,
          onCardClickAction,
          withoutCTA,
          showCardIndex,
          stickyConfig,
          listLayout: layout,
          country,
          hideProductImage: showOnlyLeadImage && index > 0,
          removeBottomMargin: showOnlyLeadImage,
          offerText,
          intermediateURLConfig,
          cardWidth,
          logoinCTAContainer,
          showOfferText,
          imageId,
          logoConfig,
          flashDealMinDiscount,
          validAffiliateList,
          validCurrencyMap,
          priceSize,
          windowFunctions: windowFunctions[index]
            ? [windowFunctions[index]]
            : [],
          mobileView,
        }}
        isMobile={isMobile}
      />
    ))
  }
  useEffect(() => {
    products.forEach((item, index) => {
      if (item.productID === activeProductID) {
        setActiveCardIndex(index)
      }
    })
  }, [activeProductID])

  useEffect(() => {
    if (!carouselIsStickyNow) {
      setActiveCardIndex(0)
    }
  }, [carouselIsStickyNow])

  const getSlider = () => (
    <SliderComponent
      sliderSettings={sliderSettings}
      ga={ga}
      useGA4={useGA4}
      ga4={ga4}
      className={containerClass}
      nudgeOnUserView={nudgeOnUserView}
      activeSlideIndexByProps={activeCardIndex}
    >
      {ProductCardList}
    </SliderComponent>
  )

  if (isSlider) {
    return SliderComponent ? getSlider() : <div className="aff_loading" />
  }

  if (layout === 'masonry' && Masonry) {
    return (
      <Masonry className={s.masonry} breakpointCols={masonry.columns}>
        {ProductCardList}
      </Masonry>
    )
  }

  return (
    <div
      className={containerClass}
      data-carousel_container={isCarousel && 'true'}
    >
      {ProductCardList}
    </div>
  )
}

ProductCardListV2.propTypes = {
  carouselIsStickyNow: PropTypes.bool,
  data: PropTypes.shape({
    products: PropTypes.arrayOf(PropTypes.shape({})),
    dataGA: PropTypes.shape({}),
    productLinkTarget: PropTypes.string,
  }),
  config: PropTypes.shape({
    cardLayout: PropTypes.string,
    cardSubLayout: PropTypes.string,
    cardHeight: PropTypes.number,
    currency: PropTypes.string,
    onCardClickAction: PropTypes.string,
    intersectionObserverRootMargin: PropTypes.string,
    withoutCTA: PropTypes.bool,
    showCardIndex: PropTypes.bool,
    ga: PropTypes.shape({
      category: PropTypes.string,
      action: PropTypes.string,
    }),
    layout: PropTypes.string,
    logoCtaLessSpace: PropTypes.string,
    masonry: PropTypes.shape({
      columns: PropTypes.number,
    }),
    hideCardDiscountPrefix: PropTypes.bool,
    cardNoPrice: PropTypes.bool,
    cardCTAText: PropTypes.string,
    darkThemeLogoMsid: PropTypes.string,
    nudgeOnUserView: PropTypes.bool,
    stickyConfig: PropTypes.shape({}),
    country: PropTypes.string,
    showOnlyLeadImage: PropTypes.bool,
    offerText: PropTypes.string,
    intermediateURLConfig: PropTypes.shape({}),
    logoConfig: PropTypes.shape({}),
    cardWidth: PropTypes.number,
    logoinCTAContainer: PropTypes.bool,
    showOfferText: PropTypes.bool,
    imageId: PropTypes.string,
    flashDealMinDiscount: PropTypes.string,
    validAffiliateList: PropTypes.shape({}),
    validCurrencyMap: PropTypes.shape({}),
    windowFunctions: PropTypes.shape([]),
    priceSize: PropTypes.string,
    useGA4: PropTypes.bool,
    mobileView: PropTypes.bool,
    affiliateName: PropTypes.string,
    ga4: PropTypes.shape({}),
  }),
  isMobile: PropTypes.bool,
  SliderComponent: PropTypes.func,
}

ProductCardListV2.defaultProps = {
  carouselIsStickyNow: false,
  data: {
    products: [],
    productLinkTarget: undefined,
    dataGA: {},
  },
  config: {
    cardLayout: 'vertical',
    currency: undefined,
    ga: {
      category: '',
      action: '',
    },
    layout: '',
    logoCtaLessSpace: '',
    masonry: {},
    hideCardDiscountPrefix: false,
    cardNoPrice: false,
    cardCTAText: '',
    darkThemeLogoMsid: undefined,
    cardSubLayout: undefined,
    onCardClickAction: '',
    intersectionObserverRootMargin: '',
    withoutCTA: false,
    showCardIndex: false,
    nudgeOnUserView: false,
    showOnlyLeadImage: false,
    stickyConfig: {},
    country: '',
    offerText: '',
    logoinCTAContainer: false,
    showOfferText: false,
    imageId: '',
    logoConfig: {},
    validAffiliateList: {},
    validCurrencyMap: {},
    priceSize: {},
    windowFunctions: [],
    flashDealMinDiscount: 40,
    useGA4: false,
    mobileView: false,
    affiliateName: '',
    ga4: {},
  },
  isMobile: false,
  SliderComponent: null,
}

export default ProductCardListV2
